/**
 *
 * @param {Image} img
 * @param {ImageType} type
 * @returns
 */
export default function resizeImage(img, type) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  let MAX_WIDTH = 1024;
  let MAX_HEIGHT = 960;
  let width = img.width;
  let height = img.height;

  if (width > height) {
    if (width > MAX_WIDTH) {
      height *= MAX_WIDTH / width;
      width = MAX_WIDTH;
    }
  } else {
    if (height > MAX_HEIGHT) {
      width *= MAX_HEIGHT / height;
      height = MAX_HEIGHT;
    }
  }

  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, 0, 0, width, height);

  let resizedImageStr = canvas.toDataURL(type, 0.7);
  return resizedImageStr;
}
